import { useEffect, useRef } from 'react';
import { PRODUCT_DISCOVERY_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useFormContext } from '@atlassian/jira-issue-create-form-context/src/index.tsx';
import type { WatchersConfig } from '@atlassian/jira-issue-create-watchers/src/services/types.tsx';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import type { ControllerFull } from '@atlassian/jira-platform-services-user-current/src/types.tsx';

export const useDefaultWatchers = ({ configs }: { configs?: WatchersConfig }) => {
	const { isAutoWatchEnabled } = configs || {};
	const [{ watchers, selectedProject }, { setWatchers }] = useFormContext();
	const {
		data: { user: currentUser },
		loading,
		error,
	} = useCurrentUser() as ControllerFull; // eslint-disable-line @typescript-eslint/consistent-type-assertions
	const hasWatchersInitialized = useRef<boolean>(false);

	const shouldShowWatchers = selectedProject && configs && !currentUser.isAnonymous;
	!loading &&
		!error &&
		// NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
		selectedProject?.projectType !== PRODUCT_DISCOVERY_PROJECT;

	useEffect(() => {
		if (!fg('default_watchers_issue_create')) return;

		if (
			isAutoWatchEnabled &&
			shouldShowWatchers &&
			currentUser &&
			watchers.length === 0 &&
			!hasWatchersInitialized.current
		) {
			setWatchers([currentUser]);
			hasWatchersInitialized.current = true;
		}
	}, [currentUser, isAutoWatchEnabled, setWatchers, watchers.length, shouldShowWatchers]);
};
